import React from 'react';
import 'katex/dist/katex.min.css';
import Latex from 'react-latex-next';
import { Typography } from '@/UIlibrary/Typography/Typography';

const TextSectionWithFormula: React.FC<{
	text: string | number;
	title: string;
	numerator: string;
	denominator: string;
	t: (key: string) => string;
	showTitle?: boolean;
}> = ({ text, title, numerator, denominator, t, showTitle = true }) => {
	return (
		<div className="flex flex-row justify-between">
			<div className="ml-4 flex flex-col justify-start">
				<Typography size="md" weight="medium">
					{showTitle ? t(title) : ''}
				</Typography>
				{numerator === 'CalculatedNetIncomeIndexNumerator' && (
					<>
						<Latex>{`$${t('CalculatedNetIncomeIndexIncome')}$`}</Latex>
						<Latex>{`$${t('CalculatedNetIncomeIndexExpenses')}$`}</Latex>
					</>
				)}
				<Latex>{`$$\\frac{${t(numerator)}}{${t(denominator)}}$$`}</Latex>
			</div>
			<Typography>{text || ''}</Typography>
		</div>
	);
};

export default TextSectionWithFormula;
